<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='备忘录管理'></PageHead>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <SearchNormalText v-model='condition.title' label='标题'></SearchNormalText>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">记录开始时间：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.createstartdate" type="month" placeholder="记录开始时间" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">记录结束时间：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.createenddate" type="month" placeholder="记录结束时间" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
          <AddButton url="/note/noteadd" buttonname="新增"></AddButton>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
            <el-table-column prop="Title" label="标题">
            </el-table-column>
            <el-table-column prop="Content" label="标题">
            </el-table-column>
            <el-table-column prop="CreateUserName" label="记录人">
            </el-table-column>
            <el-table-column label="记录时间">
              <template slot-scope="scope">
                {{scope.row.CreateDate|formatDate}}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="160">
              <template slot-scope="scope">
                <el-button @click="Edit(scope.row)" type="text" size="medium">修改</el-button>
                <el-button @click="Delete(scope.row)" type="text" size="medium" style="color: red;">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NoteList',
    data() {
      return {
        condition: {
          token: '',
          title: '',
          createstartdate: '',
          createenddate: '',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true
        },
        fullscreenLoading: false,
        tableData: null,
        searchUrl: this.$utils.Url.zpgl + '/api/APINote/List',
        loading: true
      }
    },
    filters: {
      formatDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        var d = now.getDate()
        return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
      }
    },
    methods: {
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.firstSearch = false
        this.condition.currentPage = val
        this.$refs.btnSearch.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.firstSearch = false
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.$refs.btnSearch.Search()
      },
      Edit: function(row) {
        this.$router.push({
          name: 'NoteEdit',
          params: {
            id: row.ID
          }
        })
      },
      Delete: function(row) {
        var args = {
          id: row.ID,
          token: this.condition.token
        }
        this.$utils.Delete(this.$utils.Url.zpgl + '/api/APINote/Delete', args, row.Title, this.$refs.btnSearch.Search)
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.$refs.btnSearch.Search()
    }
  }
</script>

<style scoped="scoped">
  body {
    margin: 0;
  }
</style>
